const categories = [
	{
		path: '/deals/categories/list',
		name: 'shop-categories-list',
		component: () => import('@/views/shop/categories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGS,categories',
		},
	},
]

export default categories
